import React from 'react';
import { createIcon } from './create-icon';
import './icon-labels-check-mark.scss';

export const IconLabelsCheckMark = createIcon(<div className="icon-labels-check-mark" />);
